import { ActionStatus } from '../../enums/order/action-status.enum';
import { SignerDetailVariant } from '../../types/contract-order/signer-detail-variant.type';

export const signerStatusTranslationKeyMapper = new Map<ActionStatus, string>([
  [ActionStatus.Completed, 'SIGNED'],
  [ActionStatus.Pending, 'PENDING'],
  [ActionStatus.Declined, 'REJECTED'],
]);

export const signerVariantMapper = new Map<ActionStatus, SignerDetailVariant>([
  [ActionStatus.Completed, 'success'],
  [ActionStatus.Pending, 'warning'],
  [ActionStatus.Declined, 'danger'],
]);
